import Immutable from 'immutable';
import SearchConstants from '../../constants/SearchConstants';

const DEFAULT_SEARCH_TYPE = 'smart';

const initialState = Immutable.Map({
  searchTerm: null,
  searchType: DEFAULT_SEARCH_TYPE
});

const searchTypeMap = {
  bl: 'smart',
  bkw: 'smart',
  keyword: 'smart',
  catalogue: 'smart',
  xauthor: 'author',
  xsubject: 'subject',
  composite_heading: 'subject'
};

const mapSearchType = type => searchTypeMap[type] || type;

export default function searchForm(state = initialState, action) {
  switch (action.type) {
    case SearchConstants.SEARCH_SUCCESS: {
      return state.merge({
        searchType: mapSearchType(action.payload.catalogSearch.searchType),
        searchTerm: action.payload.catalogSearch.query
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/search/SearchFormReducer.js